module.exports = __webpack_public_path__ + "img/Picture10.b2988541.jpg";